import { server } from './config'
import client from './client'

export default {
  getCities(data = {}, config = {}) {
    return client.get(`${server}/checkin/api/cities?state_id=${data}`)
  }
}
